import * as React from 'react';
import { findPageIndexByCardIndex } from '../helpers.js';

// Custom hook for handling current card positioning
var useCurrentCardEffect = function useCurrentCardEffect(carouselApi, currentCard) {
  React.useEffect(function () {
    if (typeof currentCard !== 'number' || !carouselApi) return;
    var engine = carouselApi.internalEngine();
    var groupedSlides = engine.slidesToScroll.groupSlides(carouselApi.slideNodes());
    var targetPageIndex = findPageIndexByCardIndex(groupedSlides, currentCard);
    carouselApi.scrollTo(targetPageIndex);
  }, [carouselApi, currentCard]);
};

export { useCurrentCardEffect };
//# sourceMappingURL=useCurrentCardEffect.js.map
